export default "__VITE_ASSET__22b0d2f8__"